import { useEffect } from "react";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import Homepage from "../Pages/Homepage/Homepage";

const Layout = () => {
  return (
    <div className="landing-page-root" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <Homepage />
      <Footer />
    </div>
  );
};

export default Layout;
